import axios from 'axios';
import { env } from 'env.mjs';

import useUserStore from '@/utils/store/store';

const useRedirectSacForm = () => {
  const { user } = useUserStore();

  const redirectSacByUser = async () => {
    const GUID02 = 'WebServices.Publicadores.RequerirFuncionario.ARequerirGUID02.aspx';

    const REDIRECT = 'WebServices.Publicadores.RequerirFuncionario.ARedirect.ASPX?';

    const userAuthString = localStorage.getItem('userauth');

    const userAuthObject = JSON.parse(userAuthString || '{}');

    try {
      const url = `${process.env.NEXT_PUBLIC_SOCKET_URL}${GUID02}`;

      const requestBody = {
        CliCod: env.NEXT_PUBLIC_CODE_CLIENT,
        PrdCod: env.NEXT_PUBLIC_PRODUCT_CODE,
        Funcionario: {
          FunEmlEmail: userAuthObject.email,
        },
      };

      const response = await axios.post(url, requestBody);

      const urlRedirect = `${process.env.NEXT_PUBLIC_SOCKET_URL}${REDIRECT}${response.data.GUID}`;

      window.open(urlRedirect, '_blank');
    } catch (error) {
      console.error('Error al realizar la petición:', error);
    }
  };

  return { redirectSacByUser };
};

export default useRedirectSacForm;
